module.exports = __webpack_public_path__ + "img/343ddf442b0a79ab03a900489d23504a.a2a69700.png";